import { InputCode } from "./InputCode";
import { PasswordRoot } from "./PasswordRoot";

export const Password = {
    Root: PasswordRoot,
    InputCode: InputCode
}